import React from "react";
import { contractInfoModel } from "../contractInfoModel";
import { ISearchValue, SearchTypeEnum } from "@src/components/YhPageHeader/Types";
import { YhPageHeader } from "@src/components/YhPageHeader";
import { Form, Input, Button, Select, Switch } from "antd";
import { ISearchField } from "@src/components/YhPageHeader/Types";

export function ContractPageHeader() {
  const {
    searchParam,
    initPgCfg,
    updateSearchParam,
    resetSearchParam,
    loadData, loadDs,
    contraceTypeDs, contraceHoldTypeDs,
  } = contractInfoModel();

  const searchFields = [
    {
      type: SearchTypeEnum.Select,
      xxl: 4,
      span: 4,
      placeholder: "合同户别",
      fieldName: "contractCategory",
      size: "small",
      disabled: false,
      options: contraceHoldTypeDs,
    },
    {
      type: SearchTypeEnum.Select,
      xxl: 4,
      span: 4,
      placeholder: "合同类型",
      fieldName: "contractType",
      size: "small",
      disabled: false,
      options: contraceTypeDs,
    },
    {
      type: SearchTypeEnum.Input,
      xxl: 2,
      span: 2,
      placeholder: "合同期限",
      fieldName: "contractDuration",
      size: "small",
      disabled: false
    },
    {
      type: SearchTypeEnum.RangePicker,
      xxl: 6,
      span: 6,
      placeholder: ["合同开始日期", "合同结束日期"],
      fieldName: "",
      rangePickerFieldName: ["startTime", "endTime"] as [string, string],
      format: "YYYY-MM-DD",
      size: "small",
      disabled: false,
      timeIsT: true
    },
    {
      type: SearchTypeEnum.Select,
      xxl: 2,
      span: 2,
      placeholder: "到期检索",
      fieldName: "expireQuery",
      size: "small",
      disabled: false,
      options: [
        { label: "全部合同", value: false },
        { label: "到期合同", value: true }
      ]
    },
    {
      type: SearchTypeEnum.Input,
      xxl: 3,
      span: 3,
      placeholder: "员工工号",
      fieldName: "staffId",
      size: "small",
      disabled: false
    },
    {
      type: SearchTypeEnum.Input,
      xxl: 3,
      span: 3,
      placeholder: "姓名",
      fieldName: "name",
      size: "small",
      disabled: false
    },
  ];

  return (
    <YhPageHeader
      triggerSearch={true}
      searchValues={searchParam as ISearchValue}
      searchFields={searchFields}
      onChange={updateSearchParam}
      handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
      handleReset={resetSearchParam}
    />
  );
}